import { Component, Inject } from "@angular/core";
import {
  AppCrudDialogBoilerplate,
  AppCrudDialogBoilerplateData,
} from "../boilerplates/app-crud.dialog.boilerplate";
import { AppNotificationTemplate } from "../app-notification-templates/app-notification-template.entity";
import { MDC_DIALOG_DATA, MdcDialogRef } from "@angular-mdc/web";

@Component({
  selector: "app-app-notification-template-dialog",
  templateUrl: "./app-notification-template-dialog.component.html",
  styleUrls: ["./app-notification-template-dialog.component.scss"],
})
export class AppNotificationTemplateDialogComponent extends AppCrudDialogBoilerplate<
  AppNotificationTemplate
> {
  get canSave() {
    return !!this.data.model.subject;
  }

  contentFilter = {
    allowNothing: true,
    title: "Informatie Pagina",
    icon: "pageview",
    entityName: "app.contents",
    nameField: "id",
    descriptionField: "title",
    sortField: "title",
    sortDirection: "ASC",
    filterFields: ["title", "html"],
  };

  constructor(
    @Inject(MDC_DIALOG_DATA)
    readonly data: AppCrudDialogBoilerplateData<AppNotificationTemplate>,
    protected readonly dialog: MdcDialogRef<
      AppNotificationTemplateDialogComponent
    >
  ) {
    super(data, dialog);
  }
}
